/**
 * Calculates the effective date for TLL Policy.
 */
export const getTllEffectiveDate = (): Date => {
  const now = new Date();

  let startDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const hours = now.getHours();

  if (now.getDate() > 15 || (now.getDate() === 15 && hours >= 4)) {
    startDate = new Date(now.getFullYear(), now.getMonth() + 2, 1);
  }

  return startDate;
};
